import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@quantum-ecosystem/ui-toolkit';

const FormSwitch = forwardRef(({ error, description, hint, wrapperClassName = '', style, ...props }, ref) => (
	<div className={`q-form-group q-form-switch-group ${wrapperClassName}`.trim()} style={style}>
		<Switch ref={ref} {...props} />
		{error ? <div className="q-form-error">{error}</div> : hint || description ? <div className="q-form-hint">{hint ?? description}</div> : null}
	</div>
));

FormSwitch.displayName = 'FormSwitch';
FormSwitch.propTypes = {
	error: PropTypes.node,
	description: PropTypes.node,
	hint: PropTypes.node,
	wrapperClassName: PropTypes.string,
	style: PropTypes.object,
};

export default FormSwitch;
